export default "__VITE_ASSET__DgkjnLTG__"